import React from 'react';
import {FULL_SCREEN_TOGGLE} from "./@const";

const DEBUG = false;
// const DEBUG = "LayoutItemView";

export default class LayoutItemView extends React.Component<any> {

    private ivContainerRef: React.RefObject<HTMLDivElement>

    constructor(props:any) {
        super(props);

        this.state = {
            domContainers: []
        }

        this.ivContainerRef = React.createRef<HTMLDivElement>();

        gd.itemView.layoutManager = this;
    }

    componentDidMount() {
        gd.bus.subscribe(FULL_SCREEN_TOGGLE, this, this.toggleFullScreenContainer)
    }

    componentWillUnmount() {
        gd.bus.unsubscribe(this);
    }

    toggleContainerEmptyClass(isEmpty:boolean) {
        const container = this.ivContainerRef.current;
        if (!container) return;

        if (isEmpty && !container.classList.contains('empty')) {
            container.classList.add('empty');
        } else if (!isEmpty) {
            container.classList.remove('empty');
        }

        gd.bus.triggerEvent('layout-item-view-toggle');
    }

    modifyContainerClasses(containerId: ID, addClasses: string[], removeClasses: string[]) {
        const itemViewContainer = document.getElementById(containerId);

        if (!itemViewContainer) {
            return
        }

        let hasAnyChanges: boolean = false
        _.map(addClasses, (className: string) => {
            if (!itemViewContainer.classList.contains(className)) {
                itemViewContainer.classList.add(className)
                hasAnyChanges = true
            }
        })

        _.map(removeClasses, (className: string) => {
            if (itemViewContainer.classList.contains(className)) {
                itemViewContainer.classList.remove(className)
                hasAnyChanges = true
            }
        })

        hasAnyChanges && gd.bus.triggerEvent('layout-item-view-toggle')
    }

    createContainer(domElementId:string, className?:string):HTMLDivElement | false {
        const container = this.ivContainerRef.current;
        if (!container) return false;

        // const classes = Classes('iv-view', className);
        const classes = className || 'iv-view'

        const div       = document.createElement('div');
        div.id          = domElementId;
        div.className   = classes;

        container.appendChild(div);

        return div;
    }

    destroyContainer(containerId:string) {
        DEBUG && console.log(DEBUG, ".destroyContainer()", containerId)

        const itemViewContainer = document.getElementById(containerId);
        if (itemViewContainer) {
            itemViewContainer.remove();
        }
    }

    toggleFullScreenContainer() {
        const container = this.ivContainerRef.current;
        if (!container) return;

        const ivViews = container.querySelectorAll('.iv-view');
        ivViews.forEach(view => {
            view.classList.toggle('full-screen');
        });
    }


    render() {
        return (
            <div ref={this.ivContainerRef} id="ui-iv-container" className="empty"/>
        )
    }
}
